import Collapse from 'bootstrap/js/dist/collapse'

document.addEventListener('DOMContentLoaded', () => {
	const desktopBreakpoint = window.matchMedia('(min-width: 992px)')
	const heroModules = document.querySelectorAll('.module-ecs-hero')

	heroModules.forEach((heroModule) => {
		const menuLinks = Array.from(heroModule.querySelectorAll('.ecs-hero__menu-link'))
		const ctaLink = heroModule.querySelector('.ecs-hero__cta')
		const navLinks = ctaLink ? [...menuLinks, ctaLink] : menuLinks
		const heroHash = heroModule.id ? `#${heroModule.id}` : ''
		const navDrawer = heroModule.querySelector('.ecs-hero__nav-drawer')
		const toggleButton = heroModule.querySelector('.ecs-hero__menu-toggle')

		if (!navDrawer || !toggleButton) {
			return
		}

		const trackedSections = navLinks
			.map((link) => {
				const href = link.getAttribute('href')

				if (!href || !href.startsWith('#')) {
					return null
				}

				const target = document.getElementById(href.slice(1))

				if (!target) {
					return null
				}

				return { link, target }
			})
			.filter(Boolean)

		const collapse = new Collapse(navDrawer, { toggle: false })
		let pendingHash = ''

		const hideDrawer = () => {
			if (navDrawer.classList.contains('show') || navDrawer.classList.contains('collapsing')) {
				collapse.hide()
			}
		}

		const setActiveLink = (activeLink = null) => {
			navLinks.forEach((link) => {
				const isActive = link === activeLink

				link.classList.toggle('is-active', isActive)
				if (isActive) {
					link.setAttribute('aria-current', 'location')
				} else {
					link.removeAttribute('aria-current')
				}
			})
		}

		const getNavOffset = () => heroModule.querySelector('.ecs-hero__nav-shell')?.offsetHeight ?? 0

		const getTargetTop = (target) => target.getBoundingClientRect().top + window.scrollY
		const getSectionScrollOffset = (target) => {
			const navOffset = getNavOffset()

			if (target.classList.contains('action-testimonials__section--testimonials')) {
				return navOffset + (window.innerWidth >= 992 ? 18 : 14)
			}

			if (
				target.classList.contains('approach-process__section')
				|| target.classList.contains('action-testimonials__section')
				|| target.classList.contains('disclaimer-contact__section')
			) {
				return navOffset
			}

			return 0
		}

		const getTargetScrollTop = (target) => {
			const targetTop = getTargetTop(target)

			return Math.max(targetTop - getSectionScrollOffset(target), 0)
		}

		const getTrackedSectionsInOrder = () => (
			trackedSections
				.slice()
				.sort((left, right) => getTargetTop(left.target) - getTargetTop(right.target))
		)

		const getEntryForHash = (hash) => trackedSections.find((entry) => entry.link.getAttribute('href') === hash)

		const getTargetForHash = (hash) => {
			if (!hash || !hash.startsWith('#')) {
				return null
			}

			return document.getElementById(hash.slice(1))
		}

		const setHash = (hash) => {
			const url = new URL(window.location.href)
			url.hash = hash
			window.history.pushState({}, document.title, `${url.pathname}${url.search}${url.hash}`)
		}

		const scrollToEntry = (entry, behavior = 'smooth') => {
			window.scrollTo({
				top: getTargetScrollTop(entry.target),
				behavior,
			})
		}

		const clearHash = () => {
			if (!window.location.hash) {
				return
			}

			const url = new URL(window.location.href)
			url.hash = ''
			window.history.replaceState({}, document.title, `${url.pathname}${url.search}`)
		}

		const syncActiveLinkToHash = () => {
			const currentHash = window.location.hash

			if (!currentHash || currentHash === heroHash) {
				pendingHash = ''
				setActiveLink(null)
				return
			}

			const activeEntry = getEntryForHash(currentHash)

			if (activeEntry) {
				setActiveLink(activeEntry.link)
				window.requestAnimationFrame(() => {
					const targetTop = getTargetScrollTop(activeEntry.target)

					if (Math.abs(window.scrollY - targetTop) > 2) {
						window.scrollTo({ top: targetTop, behavior: 'auto' })
					}
				})
				return
			}

			const hashTarget = getTargetForHash(currentHash)

			if (hashTarget) {
				setActiveLink(null)
				window.requestAnimationFrame(() => {
					const targetTop = getTargetScrollTop(hashTarget)

					if (Math.abs(window.scrollY - targetTop) > 2) {
						window.scrollTo({ top: targetTop, behavior: 'auto' })
					}
				})
				return
			}

			pendingHash = ''
			setActiveLink(null)
		}

		const updateActiveSection = () => {
			const orderedSections = getTrackedSectionsInOrder()

			if (!orderedSections.length) {
				return
			}

			const navOffset = getNavOffset()
			const scrollPosition = window.scrollY + navOffset + 16
			const firstSectionTop = getTargetTop(orderedSections[0].target)

			if (scrollPosition < firstSectionTop) {
				pendingHash = ''
				setActiveLink(null)
				clearHash()
				return
			}

			const currentHash = window.location.hash
			const currentHashEntry = getEntryForHash(currentHash)
			const currentHashTarget = currentHashEntry ? null : getTargetForHash(currentHash)

			if (currentHashTarget) {
				const currentHashScrollTop = getTargetScrollTop(currentHashTarget)

				if (window.scrollY >= currentHashScrollTop - 18) {
					pendingHash = ''
					setActiveLink(null)
					return
				}
			}

			if (pendingHash) {
				const pendingEntry = getEntryForHash(pendingHash)

				if (pendingEntry) {
					const pendingTargetScrollTop = getTargetScrollTop(pendingEntry.target)

					if (Math.abs(window.scrollY - pendingTargetScrollTop) > 18) {
						setActiveLink(pendingEntry.link)
						return
					}
				}

				const pendingTarget = pendingEntry ? null : getTargetForHash(pendingHash)

				if (pendingTarget) {
					const pendingTargetScrollTop = getTargetScrollTop(pendingTarget)

					if (Math.abs(window.scrollY - pendingTargetScrollTop) > 18) {
						setActiveLink(null)
						return
					}
				}

				pendingHash = ''
			}

			let activeEntry = orderedSections[0]

				orderedSections.forEach((entry, index) => {
				const previousEntry = orderedSections[index - 1]
				const nextEntry = orderedSections[index + 1]
				const currentTop = getTargetTop(entry.target)
				const startBoundary = previousEntry
					? (getTargetTop(previousEntry.target) + currentTop) / 2
					: currentTop
				const endBoundary = nextEntry
					? (currentTop + getTargetTop(nextEntry.target)) / 2
					: Number.POSITIVE_INFINITY
				const hasReachedCurrent = scrollPosition >= startBoundary
				const isBeforeNext = scrollPosition < endBoundary

					if (hasReachedCurrent && isBeforeNext) {
						activeEntry = entry
					}
				})

			setActiveLink(activeEntry?.link ?? null)
		}

		let scrollTicking = false
		const requestActiveSectionUpdate = () => {
			if (scrollTicking) {
				return
			}

			scrollTicking = true
			window.requestAnimationFrame(() => {
				updateActiveSection()
				scrollTicking = false
			})
		}

		syncActiveLinkToHash()
		updateActiveSection()
		window.addEventListener('scroll', requestActiveSectionUpdate, { passive: true })
		window.addEventListener('resize', requestActiveSectionUpdate)
		window.addEventListener('hashchange', syncActiveLinkToHash)

		navLinks.forEach((link) => {
			link.addEventListener('click', (event) => {
				if (!desktopBreakpoint.matches) {
					hideDrawer()
				}

				const href = link.getAttribute('href')?.startsWith('#') ? link.getAttribute('href') : ''
				const entry = href ? getEntryForHash(href) : null
				const target = entry ? entry.target : getTargetForHash(href)

				if (target) {
					event.preventDefault()
					pendingHash = href
					setActiveLink(link)

					setHash(href)
					window.scrollTo({
						top: getTargetScrollTop(target),
						behavior: 'smooth',
					})
					return
				}

				window.requestAnimationFrame(() => {
					window.requestAnimationFrame(updateActiveSection)
				})
			})
		})

		document.addEventListener('click', (event) => {
			if (desktopBreakpoint.matches || !navDrawer.classList.contains('show')) {
				return
			}

			if (!heroModule.contains(event.target)) {
				hideDrawer()
			}
		})

		document.addEventListener('keydown', (event) => {
			if (event.key === 'Escape' && navDrawer.classList.contains('show')) {
				hideDrawer()
				toggleButton.focus()
			}
		})

		const handleBreakpointChange = (event) => {
			if (event.matches) {
				hideDrawer()
			}
		}

		if (typeof desktopBreakpoint.addEventListener === 'function') {
			desktopBreakpoint.addEventListener('change', handleBreakpointChange)
		} else if (typeof desktopBreakpoint.addListener === 'function') {
			desktopBreakpoint.addListener(handleBreakpointChange)
		}
	})
})